
export const CardData = [
    {   
        image:  "images/website.svg" ,  
        title: "We Are Plusvans. A waste management service that disposes of all your unwanted garbage for you all while ensuring we keep the environment green.",
        linkUrl: "/portfolio-page",
        linkText:"Visite Websites",
    },
    {   
        image:  "images/app.svg",  
        title: "We Are Plusvans. A waste management service that disposes of all your unwanted garbages for you all while ensuring we keep the environment green.",
        linkUrl: "/portfolio-page",
        linkText:"Visite Mobile Apps"
    },
    {   
        image:  "images/dashboard.svg" ,  
        title: "We Are Plusvans. A waste management service that disposes of all your unwanted garbage for you all while ensuring we keep the environment green.",
        linkUrl: "/portfolio-page",
        linkText:"Visite Dashboards"
    }, 
   
]
